var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.51,
    height: 16.5,
    viewBox: "0 0 21.51 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(0.255 -2.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10282",
    "data-name": "Path 10282",
    d: "M20.921,10.628C19.2,6.832,15.313,3,10.5,3S1.8,6.832.08,10.628a.909.909,0,0,0,0,.743C1.8,15.168,5.688,19,10.5,19s8.7-3.832,10.421-7.628A.909.909,0,0,0,20.921,10.628ZM10.5,17.222c-3.86,0-7.128-3.157-8.654-6.222C3.372,7.935,6.641,4.778,10.5,4.778S17.628,7.935,19.154,11c-1.526,3.065-4.794,6.222-8.654,6.222Z",
    transform: "translate(0)",
    fill: "#808184",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10283",
    "data-name": "Path 10283",
    d: "M11.375,7a4.445,4.445,0,1,0,4.375,4.444A4.41,4.41,0,0,0,11.375,7Zm0,7.111A2.667,2.667,0,1,1,14,11.444,2.646,2.646,0,0,1,11.375,14.111Z",
    transform: "translate(-0.875 -0.444)",
    fill: "#808184",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.3ce5f5396c3dc12ceebe59a04547a483.svg";
export { ForwardRef as ReactComponent };